import { useEffect, useState } from "react";

export function useFullscreenDetection() {
  const [isFullScreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    // watch for fullscreen change in the document
    const callback = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", callback);

    return () => {
      document.removeEventListener("fullscreenchange", callback);
    };
  }, []);

  return {
    isFullScreen,
  };
}
